import React, { useState } from 'react';
import { Plus, Search, Filter, Edit, Trash2, Download, Upload, CheckSquare, Square, Eye } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { Card } from '../../components/ui/Card';
export function ProductManagement() {
  const [selectedProducts, setSelectedProducts] = useState<number[]>([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const products = [{
    id: 1,
    sku: 'SKU-IM-001',
    name: 'Indomie Goreng Special',
    category: 'Makanan',
    price: 3100,
    moq: 40,
    stock: 1250,
    status: 'active',
    image: 'https://images.unsplash.com/photo-1612929633738-8fe44f7ec841?auto=format&fit=crop&q=80&w=100'
  }, {
    id: 2,
    sku: 'SKU-AQ-002',
    name: 'Aqua Galon 19L',
    category: 'Minuman',
    price: 19500,
    moq: 5,
    stock: 45,
    status: 'low_stock',
    image: 'https://images.unsplash.com/photo-1559056199-641a0ac8b55e?auto=format&fit=crop&q=80&w=100'
  }, {
    id: 3,
    sku: 'SKU-PS-003',
    name: 'Pepsodent 190g',
    category: 'Kebersihan',
    price: 12500,
    moq: 12,
    stock: 800,
    status: 'active',
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?auto=format&fit=crop&q=80&w=100'
  }, {
    id: 4,
    sku: 'SKU-SL-004',
    name: 'Sunlight Jeruk Nipis 800ml',
    category: 'Kebersihan',
    price: 15000,
    moq: 6,
    stock: 0,
    status: 'inactive',
    image: 'https://images.unsplash.com/photo-1627485937980-221c88ac04f9?auto=format&fit=crop&q=80&w=100'
  }, {
    id: 5,
    sku: 'SKU-BR-005',
    name: 'Beras Ramos 5kg',
    category: 'Sembako',
    price: 65000,
    moq: 10,
    stock: 200,
    status: 'active',
    image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?auto=format&fit=crop&q=80&w=100'
  }];
  const toggleSelect = (id: number) => {
    setSelectedProducts(prev => prev.includes(id) ? prev.filter(p => p !== id) : [...prev, id]);
  };
  const toggleSelectAll = () => {
    setSelectedProducts(selectedProducts.length === products.length ? [] : products.map(p => p.id));
  };
  return <div className="space-y-6" data-id="element-1052">
      {/* Header Actions */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-1053">
        <div data-id="element-1054">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-1055">
            Manajemen Produk
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-1056">
            Kelola katalog produk dan inventori
          </p>
        </div>
        <div className="flex gap-2" data-id="element-1057">
          <Button variant="outline" size="sm" icon={<Download className="w-4 h-4" data-id="element-1059" />} data-id="element-1058">
            Ekspor
          </Button>
          <Button variant="outline" size="sm" icon={<Upload className="w-4 h-4" data-id="element-1061" />} data-id="element-1060">
            Import
          </Button>
          <Button variant="primary" icon={<Plus className="w-4 h-4" data-id="element-1063" />} onClick={() => setShowAddModal(true)} data-id="element-1062">
            Tambah Produk
          </Button>
        </div>
      </div>

      {/* Search & Filter */}
      <div className="flex gap-2" data-id="element-1064">
        <div className="relative flex-1" data-id="element-1065">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-1066" />
          <input type="text" placeholder="Cari produk berdasarkan nama atau SKU..." className="w-full pl-10 pr-4 py-2 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1067" />
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-lg text-sm font-medium text-slate-600 hover:bg-slate-50" data-id="element-1068">
          <Filter className="w-4 h-4" data-id="element-1069" />
          Filter
        </button>
      </div>

      {/* Bulk Actions */}
      {selectedProducts.length > 0 && <Card className="p-4 bg-blue-50 border-blue-200" data-id="element-1070">
          <div className="flex items-center justify-between" data-id="element-1071">
            <span className="font-bold text-blue-900" data-id="element-1072">
              {selectedProducts.length} produk dipilih
            </span>
            <div className="flex gap-2" data-id="element-1073">
              <Button variant="outline" size="sm" data-id="element-1074">
                Aktifkan
              </Button>
              <Button variant="outline" size="sm" data-id="element-1075">
                Nonaktifkan
              </Button>
              <Button variant="outline" size="sm" className="text-red-600 border-red-200 hover:bg-red-50" data-id="element-1076">
                Hapus
              </Button>
            </div>
          </div>
        </Card>}

      {/* Product Table */}
      <Card className="overflow-hidden" data-id="element-1077">
        <div className="overflow-x-auto" data-id="element-1078">
          <table className="w-full" data-id="element-1079">
            <thead className="bg-slate-50 border-b border-slate-200" data-id="element-1080">
              <tr data-id="element-1081">
                <th className="px-4 py-3 text-left" data-id="element-1082">
                  <button onClick={toggleSelectAll} data-id="element-1083">
                    {selectedProducts.length === products.length ? <CheckSquare className="w-5 h-5 text-blue-600" data-id="element-1084" /> : <Square className="w-5 h-5 text-slate-400" data-id="element-1085" />}
                  </button>
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-slate-700" data-id="element-1086">
                  Produk
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-slate-700" data-id="element-1087">
                  SKU
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-slate-700" data-id="element-1088">
                  Kategori
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-slate-700" data-id="element-1089">
                  Harga
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-slate-700" data-id="element-1090">
                  MOQ
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-slate-700" data-id="element-1091">
                  Stok
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-slate-700" data-id="element-1092">
                  Status
                </th>
                <th className="px-4 py-3 text-right text-sm font-bold text-slate-700" data-id="element-1093">
                  Aksi
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-1094">
              {products.map(product => <tr key={product.id} className={`hover:bg-slate-50 ${selectedProducts.includes(product.id) ? 'bg-blue-50' : ''}`} data-id="element-1095">
                  <td className="px-4 py-4" data-id="element-1096">
                    <button onClick={() => toggleSelect(product.id)} data-id="element-1097">
                      {selectedProducts.includes(product.id) ? <CheckSquare className="w-5 h-5 text-blue-600" data-id="element-1098" /> : <Square className="w-5 h-5 text-slate-400" data-id="element-1099" />}
                    </button>
                  </td>
                  <td className="px-4 py-4" data-id="element-1100">
                    <div className="flex items-center gap-3" data-id="element-1101">
                      <img src={product.image} alt="" className="w-12 h-12 rounded-lg object-cover bg-slate-100" data-id="element-1102" />
                      <span className="font-medium text-slate-900" data-id="element-1103">
                        {product.name}
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-4" data-id="element-1104">
                    <span className="text-xs font-mono text-slate-600" data-id="element-1105">
                      {product.sku}
                    </span>
                  </td>
                  <td className="px-4 py-4" data-id="element-1106">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800" data-id="element-1107">
                      {product.category}
                    </span>
                  </td>
                  <td className="px-4 py-4" data-id="element-1108">
                    <span className="font-bold text-blue-600" data-id="element-1109">
                      Rp {product.price.toLocaleString('id-ID')}
                    </span>
                  </td>
                  <td className="px-4 py-4" data-id="element-1110">
                    <span className="text-sm text-slate-600" data-id="element-1111">
                      {product.moq} unit
                    </span>
                  </td>
                  <td className="px-4 py-4" data-id="element-1112">
                    <span className={`font-medium ${product.stock < 50 ? 'text-red-600' : 'text-slate-900'}`} data-id="element-1113">
                      {product.stock} unit
                    </span>
                  </td>
                  <td className="px-4 py-4" data-id="element-1114">
                    <Badge variant={product.status === 'active' ? 'success' : product.status === 'low_stock' ? 'warning' : 'neutral'} data-id="element-1115">
                      {product.status === 'active' ? 'Aktif' : product.status === 'low_stock' ? 'Stok Rendah' : 'Nonaktif'}
                    </Badge>
                  </td>
                  <td className="px-4 py-4" data-id="element-1116">
                    <div className="flex justify-end gap-1" data-id="element-1117">
                      <button className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors" data-id="element-1118">
                        <Eye className="w-4 h-4" data-id="element-1119" />
                      </button>
                      <button className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors" data-id="element-1120">
                        <Edit className="w-4 h-4" data-id="element-1121" />
                      </button>
                      <button className="p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors" data-id="element-1122">
                        <Trash2 className="w-4 h-4" data-id="element-1123" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Pagination */}
      <div className="flex items-center justify-between" data-id="element-1124">
        <p className="text-sm text-slate-600" data-id="element-1125">
          Menampilkan <span className="font-bold" data-id="element-1126">1-5</span> dari{' '}
          <span className="font-bold" data-id="element-1127">48</span> produk
        </p>
        <div className="flex gap-2" data-id="element-1128">
          <Button variant="outline" size="sm" data-id="element-1129">
            Sebelumnya
          </Button>
          <Button variant="outline" size="sm" data-id="element-1130">
            1
          </Button>
          <Button variant="primary" size="sm" data-id="element-1131">
            2
          </Button>
          <Button variant="outline" size="sm" data-id="element-1132">
            3
          </Button>
          <Button variant="outline" size="sm" data-id="element-1133">
            Selanjutnya
          </Button>
        </div>
      </div>
    </div>;
}